import styled from '@emotion/styled'
import type { MouseEvent, ReactNode } from 'react'

/** หัวข้อ modal กำหนด SKU — ราคาและสต๊อก */
export const SKU_MODAL_TITLE = 'กำหนดรายละเอียดตัวเลือกสินค้า — ราคาและสต๊อก' as const

export const getSkuModalTitle = (options?: {
  editMode?: boolean
  copyMode?: boolean
}): string => {
  if (options?.copyMode) return 'คัดลอกตัวเลือก — ราคาและสต๊อก'
  if (options?.editMode) return 'แก้ไขตัวเลือกสินค้า'
  return SKU_MODAL_TITLE
}

const INTERACTIVE_SELECTOR =
  'input, textarea, button, a, .ant-select, .ant-segmented, .ant-upload, .ant-switch, .ant-modal-close'

/**
 * ลากย้าย Ant Design Modal ได้
 * - ลากจากหัวข้อ modal (.ant-modal-header) เป็นหลัก
 * - ไม่ลากเมื่อคลิกปุ่มปิดหรือ element ที่โต้ตอบได้
 * - ใช้ transform: translate() แทน position: fixed เพื่อหลีกเลี่ยงปัญหา layout ของ AntD
 */
export const handleSkuModalDrag = (e: MouseEvent<HTMLElement>) => {
  const target = e.target as HTMLElement
  if (target.closest(INTERACTIVE_SELECTOR)) return

  const wrapper = e.currentTarget
  const modalElement = wrapper.querySelector('.ant-modal') as HTMLElement | null
  if (!modalElement) return

  const header = modalElement.querySelector('.ant-modal-header')
  if (!header?.contains(target)) return

  e.preventDefault()

  // อ่าน translate ปัจจุบัน (จาก inline style) เพื่อรองรับการลากหลายรอบต่อเนื่อง
  const matrix = new DOMMatrix(modalElement.style.transform || 'none')
  const startTranslateX = matrix.m41
  const startTranslateY = matrix.m42
  const startX = e.clientX
  const startY = e.clientY

  // ป้องกัน text selection ระหว่างลาก
  modalElement.style.userSelect = 'none'

  const handleMouseMove = (moveEvent: globalThis.MouseEvent) => {
    const dx = moveEvent.clientX - startX
    const dy = moveEvent.clientY - startY
    modalElement.style.transform = `translate(${startTranslateX + dx}px, ${startTranslateY + dy}px)`
  }

  const handleMouseUp = () => {
    document.removeEventListener('mousemove', handleMouseMove)
    document.removeEventListener('mouseup', handleMouseUp)
    modalElement.style.userSelect = ''
  }

  document.addEventListener('mousemove', handleMouseMove)
  document.addEventListener('mouseup', handleMouseUp)
}

type SkuDraggableModalTitleProps = {
  children: ReactNode
}

/** หัวข้อ modal ที่ลากย้ายได้ (ใช้กับ prop title ของ Ant Design Modal) */
export const SkuDraggableModalTitle = ({ children }: SkuDraggableModalTitleProps) => (
  <TitleDragHandle>{children}</TitleDragHandle>
)

const TitleDragHandle = styled.span`
  display: inline-block;
  width: calc(100% - 32px);
  cursor: move;
  user-select: none;
`
